import { useMutation } from '@tanstack/react-query';
import { DataExtractionService } from '@/infra/services/data-extraction';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';

interface GetDataExtractionCSVToDownloadParams  {
	organization_id: string;
	company_id: string;
	data_extraction_id: string;
}

const Service = DataExtractionService.getInstance();

export const useGetDataExtractionCSVToDownload = () => {
	return useMutation({
		mutationFn: async (params: GetDataExtractionCSVToDownloadParams) => Service.getDataExtractionCSVToDownload(params),
        onSuccess: () => {
            message.success(I18n.get('Data Extraction CSV file created successfully! Download in progress.'));
        },
        onError: () => {
            message.error(I18n.get('Unable to download the data extraction file. Please try again.'));
        }
	});
}
